/**
 * Iter 85 — Desplegable "Contacto con cliente" con botón "Gestionar opciones".
 *
 * Reglas:
 *   - Muestra sólo canales `active=true` en el desplegable.
 *   - Placeholder: "Seleccionar contacto" (value="").
 *   - Si `value` es un canal desactivado o un valor legado (ej. reparación
 *     antigua importada), se muestra tal cual sin marca (compatibilidad).
 *   - El botón "Gestionar opciones" abre `ContactChannelManagerModal`.
 */
import { useState } from "react";
import { Settings2 } from "lucide-react";
import ContactChannelManagerModal from "./ContactChannelManagerModal";

export default function ContactChannelSelect({ value, onChange, catalog = [], onCatalogChange, hideManage = false }) {
  const [showManage, setShowManage] = useState(false);
  const active = catalog.filter((c) => c.active);
  const legacyName = value && !active.some((c) => c.name === value) ? value : "";

  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">
          Contacto con cliente
        </label>
        {!hideManage && (
          <button
            type="button"
            onClick={() => setShowManage(true)}
            data-testid="contact-channel-manage"
            className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest text-[#525252] hover:text-[#6E8B3D]"
            title="Gestionar opciones del desplegable"
          >
            <Settings2 size={12} /> Gestionar opciones
          </button>
        )}
      </div>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        data-testid="repair-contact-channel"
        className="mt-1 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-2 text-sm rounded-none"
      >
        <option value="">Seleccionar contacto</option>
        {legacyName && (
          <option value={legacyName}>{legacyName}</option>
        )}
        {active.map((c) => (
          <option key={c.id} value={c.name}>{c.name}</option>
        ))}
      </select>

      {showManage && (
        <ContactChannelManagerModal
          initialList={catalog}
          onClose={() => setShowManage(false)}
          onSaved={(next) => { onCatalogChange?.(next); setShowManage(false); }}
        />
      )}
    </div>
  );
}
